import { PLAUSIBLE_HOST } from '../constants'

/**
 * Fires a custom Plausible event, attributed to a game's own hosted site (its own Plausible
 * "site"), matching how each tiiny-hosted site already gets its own analytics property.
 * Fire-and-forget - never blocks the UI action it's attached to.
 */
export const trackGameEvent = (subdomain, name) => {
  if (!subdomain || !name) return

  try {
    fetch(`${PLAUSIBLE_HOST}/api/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        domain: subdomain,
        url: window.location.href
      }),
      keepalive: true
    }).catch(() => {})
  } catch {
    // Analytics should never break the page
  }
}
